import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

/* ScrollTrigger.normalizeScroll(true); */

export default class Gnav {
    constructor() {
        this.init();

        window.onresize = () => {
            ScrollTrigger.refresh();
        };
    }

    init() {
        this.trigger = document.querySelector(".js-gnav_trigger");

        this.switchGnav();
        this.clickLink();
    }

    switchGnav() {
        this.trigger.addEventListener("click", (el) => {
            if (this.trigger.classList.contains("-active")) {
                this._hideGnav();
            } else {
                this._showGnav();
            }
        });
    }

    clickLink() {
        const link = [...document.querySelectorAll(".js-gnav_item")];

        link.forEach((el) => {
            el.addEventListener("click", () => {
                this._hideGnav();
            });
        });
    }

    _showGnav() {
        this.trigger.classList.add("-active");
        document.body.classList.add("-gnav_open");
        document.body.classList.add("-lock");
    }

    _hideGnav() {
        this.trigger.classList.remove("-active");
        document.body.classList.remove("-gnav_open");
        document.body.classList.remove("-lock");
    }
}
